import {StyleSheet} from 'react-native';
import {random} from 'lodash';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  footer: {
    marginVertical: indent,
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerBoxPremierMember: {
    width: `${random(10, 15)}%`,
    height: 14,
  },
  footerBoxLastOrderDate: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
  footerBoxPQV: {
    width: `${random(10, 15)}%`,
    height: 14,
  },
  footerBoxCoach: {
    width: `${random(20, 35)}%`,
    height: 14,
  },
});
